export const locale = {
    lang: 'en',
    data: {
        NOTIFICATION_BELL: {
            CLOSE: 'Close',
            WHATS_NEW: 'What\'s new?',
            MARK_ALL_READ: 'Mark All as Read',
            UNREAD_ONLY: 'Unread only',
            ALL: 'All',
            MY_ACTIVITY: 'My Activity',
            CUSTOMER_ACTIVITY: 'Customer Activity',
            TODAY: 'Today',
            YESTERDAY: 'Yesterday',
            OLDER: 'Older',
            LATEST: 'Latest',
            DISCLAIMER: 'That\'s all your notifications from the last 30 days.',
            UNREAD_DISCLAIMER: 'That\'s all your unread notifications from the last 30 days.',
            ZERO_STATE: 'There are no new notifications.',
            NO_NOTIFICATIONS: 'No Notifications',
            YOU_WILL_BE_NOTIFIED: 'You will be notified here for new matches, price drops, messages and more'
        }
    }
};